import type { OpportunityCustomizationProjectItem } from "../../crm_opportunity_workbench/types";

/** 从商机关联定制生成可写入新项目左侧需求追溯的文案。 */
export function buildOpportunityProjectCopyTraceContent(
  project: OpportunityCustomizationProjectItem,
): string {
  const source = project.sourceTraceSummary?.trim();
  if (source) {
    return source;
  }
  const demand = project.demandSummary?.trim();
  if (demand) {
    return demand;
  }
  const code = project.projectCode?.trim();
  const name = project.projectName?.trim() || "未命名定制";
  return code ? `${name}（${code}）` : name;
}
